import type { z } from "zod";
import { EnrichedCompanySchema } from "./enriched-company.schemas.js";

/**
 * Projected, secret-free admin view of an enriched company, keyed by public id.
 * Derived (`.pick`) from the shared `EnrichedCompany` domain entity that the
 * backend enriched-company type also extends, so `.parse(backendObject)` is
 * safe by construction. The raw provider payload, external ids, input data, and
 * internal Mongo id live only on the backend type and are therefore never
 * selected here. The timestamp is a coerced date serialized to ISO on the wire.
 */
export const EnrichedCompanyViewSchema = EnrichedCompanySchema.unwrap().pick({
  idPublic: true,
  name: true,
  domain: true,
  industry: true,
  sizeRange: true,
  employeeCount: true,
  headquarters: true,
  description: true,
  country: true,
  linkedInUrl: true,
  linkedInOrgId: true,
  websiteUrl: true,
  logoUrl: true,
  foundedYear: true,
  annualRevenue: true,
  companyType: true,
  followerCount: true,
  specialties: true,
  enrichmentSource: true,
  enrichmentConfidence: true,
  enrichedAt: true,
});

export type EnrichedCompanyView = z.infer<typeof EnrichedCompanyViewSchema>;
